<div class="modal-backdrop fade"
     [class.show]="show"></div>
<div class="modal d-block fade"
     [class.show]="show"
     tabindex="-1"
     role="dialog"
     aria-labelledby="modalIdLabel">
  <div role="document"
       class="modal-dialog modal-dialog-centered"
       style="max-width: 25%">
    <div class="modal-content"
         style="min-height: 60vh">
      <div class="modal-header">
        <h5 class="modal-title text-primary-dark">Add Scope</h5>
        <button type="button"
                class="close"
                (click)="close()"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <select class="form-control"
                  id="country"
                  (change)="onCountryChange($event)"
                  [(ngModel)]="selectedCountry"
                  aria-describedby="producthelp">
            <option value=""
                    disabled>Select Country</option>
            <option *ngFor="let country of countries$|async"
                    [value]="country.id">
              {{ country.country }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <p-multiSelect [options]="districts$|async"
                         [(ngModel)]="selectedDistricts"
                         optionLabel="district">
          </p-multiSelect>
        </div>
        <div class="form-group">
          <label required>Additional cost per unit of charge</label>
          <input type="number"
                  class="form-control"
                  [(ngModel)]="extra_cost_per_unit"
                 placeholder="Enter additional cost">
        </div>
        <div class="form-group">
          <small>
            <span class="text-success">
              <ezy-icons src="/assets/icons/exclamation-circle.svg"></ezy-icons>
            </span>
            <span class="text-primary-dark">If no places are added, Service will be available in the entire
              country</span>
          </small>
        </div>
        <div class="form-group"
             style="max-height: 300px;
        overflow: scroll;">
          <!-- list of selected items -->
          <ul class="list-group">
            <li *ngFor="let district of selectedDistricts"
                class="list-group-item">
              {{ district.district }}
            </li>
          </ul>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn btn-secondary"
                (click)="close()">
          Cancel
        </button>
        <button type="button"
                *hasPermission="['services:edit_service_scoping']"
                (click)="addScope()"
                class="btn btn-primary">Save Changes</button>
      </div>
    </div>
  </div>
